import React, { RefObject } from "react";

import { CanvasThrobber } from "./CanvasThrobber";
import { CanvasThrobberLine } from "./CanvasThrobberLine";
import { CanvasThrobberRect } from "./CanvasThrobberRect";

/**
 * Specification of props for the download throbber
 */
export type DownloadThrobberProps = {
  ref?: RefObject<HTMLDivElement | null>;

  /**
   * The color of the elements that are drawn inside the canvas. Default value
   * is #ddd.
   */
  color?: string;

  /**
   * If set to false, the circle around the throbber will visually not be
   * drawn initially. Default value is true.
   */
  drawCircle?: boolean;

  /**
   * The duration specified in milliseconds of a full animation cycle. Default
   * value is 3300.
   */
  duration?: number;

  /**
   * The size of the throbber in pixels (this will be used to apply both width
   * and height to the throbber). Default value is 64.
   */
  size?: number;
};

/**
 * Renders a throbber that will display an arrow and draw a content-symbol.
 * For reference, see the throbber in i-bog 4.
 */
// tslint:disable-next-line variable-name
export const CanvasPageThrobber = (props: DownloadThrobberProps) => (
  <div ref={props.ref}>
    <CanvasThrobber
      color={props.color ?? "#ddd"}
      duration={props.duration ?? 3300}
      size={props.size ?? 64}
      drawCircle={props.drawCircle ?? true}
    >
      <CanvasThrobberRect x={7} y={7} w={7} h={7} duration={62.5} delay={0} />
      <CanvasThrobberLine
        x1={15}
        y1={7}
        x2={22}
        y2={7}
        delay={15}
        duration={67.5}
        w={1}
      />
      <CanvasThrobberLine
        x1={15}
        y1={9}
        x2={25}
        y2={9}
        delay={17.5}
        duration={80}
        w={1}
      />
      <CanvasThrobberLine
        x1={15}
        y1={11}
        x2={26}
        y2={11}
        delay={12.5}
        duration={57.5}
        w={1}
      />
      <CanvasThrobberLine
        x1={15}
        y1={13}
        x2={20}
        y2={13}
        delay={15}
        duration={60}
        w={1}
      />
      <CanvasThrobberLine
        x1={7}
        y1={15}
        x2={25}
        y2={15}
        duration={100}
        delay={0}
        w={1}
      />
      <CanvasThrobberLine
        x1={7}
        y1={17}
        x2={26}
        y2={17}
        duration={65}
        delay={0}
        w={1}
      />
      <CanvasThrobberLine
        x1={7}
        y1={19}
        x2={17}
        y2={19}
        duration={77.5}
        delay={0}
        w={1}
      />
      <CanvasThrobberLine
        x1={7}
        y1={21}
        x2={25}
        y2={21}
        duration={100}
        delay={0}
        w={1}
      />
      <CanvasThrobberLine
        x1={7}
        y1={23}
        x2={24}
        y2={23}
        duration={82.5}
        delay={0}
        w={1}
      />
      <CanvasThrobberLine
        x1={7}
        y1={25}
        x2={19}
        y2={25}
        duration={87.5}
        delay={0}
        w={1}
      />
    </CanvasThrobber>
  </div>
);
